import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export interface User {
  id: number;
  email: string;
  coins: number;
  is_verified: boolean;
}

export interface LoginResponse {
  message: string;
  user: User;
  token: string;
}

export interface RegisterResponse {
  message: string;
  user: User;
  emailSent: boolean;
}

export const authService = {
  async register(email: string, password: string): Promise<RegisterResponse> {
    const response = await axios.post(`${API_BASE_URL}/auth/register`, {
      email,
      password
    });
    return response.data;
  },

  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, {
      email,
      password
    });
    return response.data;
  },

  async resendVerificationEmail(email: string): Promise<{ message: string }> {
    const response = await axios.post(`${API_BASE_URL}/auth/resend-verification`, {
      email
    });
    return response.data;
  },

  async getProfile(): Promise<{ user: User }> {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE_URL}/auth/profile`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
}; 